import React from 'react';
import * as S from './InputLabel.styles';
const InputLabel = /*#__PURE__*/React.forwardRef(({
  children,
  htmlFor,
  inputState,
  optional,
  required,
  orientation
}, ref) => {
  const optionalText = /*#__PURE__*/React.createElement(S.OptionalText, {
    variant: "ui",
    size: orientation === 'horizontal' ? 'small' : 'medium'
  }, "\xA0(optional)");
  return /*#__PURE__*/React.createElement(S.LabelRoot, {
    ref: ref,
    htmlFor: htmlFor,
    "data-horizontal": orientation === 'horizontal',
    $state: inputState,
    $isHorizontal: orientation === 'horizontal'
  }, children, " ", optional ? optionalText : null, !!required ? /*#__PURE__*/React.createElement(S.RequiredIcon, {
    "aria-hidden": true
  }, "*") : null);
});
export { InputLabel };